import { fetchOrgUsers } from "./orgUsers";

const notifyUrl = process.env.REACT_APP_COACH_NOTIFY_URL;
const notifyToken = process.env.REACT_APP_COACH_NOTIFY_TOKEN;
const defaultTo = process.env.REACT_APP_COACH_NOTIFY_TO || "coach@xxdevelopments.co.za";

export async function notifyCoachEmail(payload = {}) {
  if (!notifyUrl || !notifyToken) return;
  const rawTo = payload.to || defaultTo;
  const recipients = Array.isArray(rawTo)
    ? rawTo
    : String(rawTo || "")
        .split(",")
        .map((email) => email.trim())
        .filter(Boolean);
  const uniqueRecipients = Array.from(
    new Set(recipients.map((email) => String(email || "").trim().toLowerCase()).filter(Boolean))
  );
  if (!uniqueRecipients.length) return;
  try {
    await Promise.all(
      uniqueRecipients.map((to) =>
        fetch(notifyUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-COACH-TOKEN": notifyToken,
          },
          body: JSON.stringify({
            to,
            subject: payload.subject || "Coach Alert",
            message: payload.message || "New coach alert.",
          }),
        })
      )
    );
  } catch {
    // silent fallback
  }
}

export async function notifyCoachForOrg(user, orgId, payload = {}) {
  if (!notifyUrl || !notifyToken) return;
  const safeOrg = orgId || user?.orgId || "org_default";
  let emails = [];
  try {
    const orgUsers = await fetchOrgUsers(user, safeOrg);
    emails = orgUsers
      .filter((u) => String(u.role || "").toLowerCase() === "coach")
      .map((u) => u.email)
      .filter(Boolean);
  } catch {}
  if (!emails.length) {
    emails = [defaultTo];
  }
  await notifyCoachEmail({
    ...payload,
    to: emails,
  });
}
